(function () {
  function initQubeVideoCarousel() {
    const videos = document.querySelectorAll('.qube-native-video');
    if (!videos.length) return;

    // Initialize Swiper
    const swiper = new Swiper('.qube-video-swiper', {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: true,
      slideToClickedSlide: true,
      spaceBetween: 30,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 2.5,
        slideShadows: false,
      },
      navigation: {
        nextEl: '.slider-button--next',
        prevEl: '.slider-button--prev',
      },
      on: {
        slideChangeTransitionEnd: function () {
          // Mute and pause all non-active videos
          document.querySelectorAll('.qube-video-swiper .swiper-slide .qube-native-video').forEach(function (v) {
            const slide = v.closest('.swiper-slide');
            if (slide && !slide.classList.contains('swiper-slide-active')) {
              v.muted = true;
              v.pause();
              // Show the "Tap for sound" badge again on side videos
              const overlay = v.nextElementSibling;
              if (overlay) overlay.classList.remove('qube-overlay-hidden');
              delete v.dataset.userControlled;
            }
          });

          // Unmute and play the active center video
          const activeSlide = document.querySelector('.qube-video-swiper .swiper-slide-active');
          if (activeSlide) {
            const activeVideo = activeSlide.querySelector('.qube-native-video');
            if (activeVideo) {
              activeVideo.muted = false;
              activeVideo.play().catch(function () {
                // If unmuted autoplay is blocked, fall back to muted
                activeVideo.muted = true;
                activeVideo.play().catch(function () {});
              });
              const overlay = activeVideo.nextElementSibling;
              if (overlay) overlay.classList.add('qube-overlay-hidden');
            }
          }
        }
      }
    });

    // IntersectionObserver: autoplay muted when visible
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          const video = entry.target;
          if (entry.isIntersecting) {
            // Only autoplay if it's the active slide
            const slide = video.closest('.swiper-slide');
            if (slide && slide.classList.contains('swiper-slide-active') && !video.dataset.userControlled) {
              video.muted = true;
              video.play().catch(function () {});
            }
          } else {
            if (!video.dataset.userControlled) {
              video.pause();
            }
          }
        });
      },
      { threshold: 0.4 }
    );

    videos.forEach(function (video) {
      observer.observe(video);

      video.addEventListener('click', function () {
        const overlay = video.nextElementSibling;
        video.muted = !video.muted;
        video.dataset.userControlled = 'true';
        
        if (video.paused) {
          video.play().catch(e => console.log(e));
        }

        if (overlay) {
          if (video.muted) {
            overlay.classList.remove('qube-overlay-hidden');
          } else {
            overlay.classList.add('qube-overlay-hidden');
          }
        }
      });

      const overlay = video.nextElementSibling;
      if (overlay && overlay.classList.contains('qube-video-muted-overlay')) {
        overlay.addEventListener('click', function () {
          video.muted = false;
          video.dataset.userControlled = 'true';
          video.play().catch(e => console.log(e));
          overlay.classList.add('qube-overlay-hidden');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQubeVideoCarousel);
  } else {
    initQubeVideoCarousel();
  }
})();

